var map = {
	"./404.svg": 982,
	"./Categories.png": 731,
	"./Edit-menu.svg": 983,
	"./Egg.svg": 984,
	"./Emaier-Header.png": 985,
	"./Qr-4.png": 986,
	"./_duplicate.svg": 987,
	"./_overview.svg": 988,
	"./add-white.svg": 989,
	"./alert.svg": 990,
	"./all_category.svg": 991,
	"./archive.svg": 992,
	"./armchair.svg": 993,
	"./arrow-circle-right.svg": 994,
	"./arrow-left-circle.svg": 995,
	"./arrow-right-circle.svg": 996,
	"./arrow-right.svg": 997,
	"./asc-up-white.svg": 998,
	"./asc.png": 999,
	"./asc.svg": 1000,
	"./back-arrow.svg": 1001,
	"./barcode-icon.svg": 1002,
	"./beverages.svg": 1003,
	"./blue-edit-pen.svg": 1004,
	"./blue-eye.svg": 1005,
	"./box-office.svg": 1006,
	"./broken-seat.jpg": 1007,
	"./calendar_list.svg": 1008,
	"./calender.svg": 376,
	"./chevron-down.svg": 1009,
	"./chevron-left.svg": 1010,
	"./cinema-mamagement-sidebar.svg": 1011,
	"./claendar.svg": 377,
	"./clock-1.svg": 1012,
	"./clock.svg": 1013,
	"./close-button.svg": 738,
	"./close-white.svg": 744,
	"./close-x.svg": 321,
	"./collapse-up.svg": 1014,
	"./collapse.svg": 1015,
	"./connection-lost.svg": 374,
	"./consumable-raw-material.svg": 1016,
	"./copy.svg": 1017,
	"./copy_image_icon.png": 1018,
	"./delete-red-light.svg": 1019,
	"./delete-red.svg": 745,
	"./delete.svg": 719,
	"./deliver-icon.svg": 1020,
	"./desc-down-white.svg": 1021,
	"./desc.svg": 1022,
	"./distributors-sidebar.svg": 1023,
	"./download.svg": 1024,
	"./dragndrop.svg": 1025,
	"./dragndrop2.svg": 1026,
	"./duplicate.svg": 1027,
	"./duplicateScreen.svg": 1028,
	"./e-wallet-icon-black.svg": 1029,
	"./edit-pen-blue.svg": 1030,
	"./edit-pen-white.svg": 1031,
	"./edit-pen.svg": 1032,
	"./edit.svg": 1033,
	"./email.png": 1034,
	"./empty-image.svg": 1035,
	"./excel.svg": 1036,
	"./external-link.svg": 1037,
	"./eye.svg": 1038,
	"./filter-icon.svg": 1039,
	"./flag.svg": 1040,
	"./fnb-app-order.svg": 1041,
	"./fnb-beverages.svg": 1042,
	"./fnb-brownie.svg": 1043,
	"./fnb-combo.svg": 1044,
	"./fnb-desert.svg": 1045,
	"./fnb-eatables.svg": 1046,
	"./fnb-make-your-combo.svg": 1047,
	"./fnb-popcorn.svg": 1048,
	"./fnbtransactionIcon.svg": 1049,
	"./fullscreen-icon.svg": 746,
	"./funnel.svg": 1050,
	"./globe.svg": 1051,
	"./green-tick.svg": 1052,
	"./grid-view.svg": 1053,
	"./hide-password.svg": 378,
	"./home-icon.svg": 1054,
	"./home.svg": 1055,
	"./icon-black-play.svg": 1056,
	"./icon-dot.svg": 1057,
	"./icon-fnb.svg": 1058,
	"./icon-marketing.svg": 1059,
	"./icon-no-seat.png": 1060,
	"./icon-no-seat.svg": 1061,
	"./icon-option.svg": 1062,
	"./icon-poin-of-sale.svg": 1063,
	"./icon-recliner.svg": 1064,
	"./icon-report.svg": 1065,
	"./icon-sofa-dark-1.svg": 1066,
	"./icon-sofa-dark.png": 1067,
	"./icon-sofa-dark.svg": 1068,
	"./icon-sofa.svg": 1069,
	"./importfile.svg": 1070,
	"./info.svg": 747,
	"./info2.svg": 1071,
	"./keyboard-icon.svg": 1072,
	"./kitchen_display.svg": 1073,
	"./language-icon.svg": 1074,
	"./left-caret.svg": 1075,
	"./link.svg": 1076,
	"./list-view.svg": 1077,
	"./loading.svg": 379,
	"./lock.svg": 1078,
	"./login-password.png": 380,
	"./login-user.png": 381,
	"./logout.svg": 748,
	"./masters-sidebar.svg": 1079,
	"./merchandise.svg": 1080,
	"./minus.svg": 1081,
	"./movie-pass-svg.svg": 729,
	"./movie-rolling.svg": 1082,
	"./mulitSchedule.svg": 1083,
	"./multicurrency.svg": 1084,
	"./multifnb.svg": 1085,
	"./nav-plus.svg": 1086,
	"./new_filter_icon.svg": 1087,
	"./no-image.svg": 1088,
	"./no-schedule.svg": 149,
	"./non-veg-mark.png": 1089,
	"./non-veg-mark.svg": 1090,
	"./notification.svg": 1091,
	"./open-link-blue.svg": 1092,
	"./openPlanned.svg": 1093,
	"./overview.svg": 1094,
	"./overview2.svg": 1095,
	"./pdf-icon.svg": 1096,
	"./pdf.svg": 1097,
	"./pickup-ticket-icon.svg": 1098,
	"./pickupfnb.svg": 1099,
	"./play.svg": 1100,
	"./plus.svg": 1101,
	"./pointofsale-1.svg": 1102,
	"./pointofsale-2.svg": 1103,
	"./pointofsale.png": 1104,
	"./portfolio.svg": 1105,
	"./pos-fnb-no-itmes.svg": 732,
	"./pos-refresh.svg": 1106,
	"./primary/chevron-down.svg": 1107,
	"./primary/download.svg": 1108,
	"./primary/edit.svg": 1109,
	"./primary/filter.svg": 1110,
	"./primary/printer.svg": 1111,
	"./print-icon.svg": 1112,
	"./print.svg": 1113,
	"./question.svg": 1114,
	"./question1.svg": 1115,
	"./question2.svg": 749,
	"./question3.svg": 1116,
	"./recliner-1.svg": 1117,
	"./recliner.png": 1118,
	"./refund-icon.svg": 1119,
	"./reload-icon-pos.svg": 1120,
	"./reload-icon.svg": 1121,
	"./restore.svg": 1122,
	"./right-caret.svg": 1123,
	"./role-management-sidebar.svg": 1124,
	"./save.svg": 1125,
	"./schedule-icon.svg": 1126,
	"./school-calendar.svg": 1127,
	"./search-global-white.svg": 1128,
	"./search-global.svg": 1129,
	"./search.svg": 750,
	"./searchIcon.svg": 1130,
	"./seat-icon-2.svg": 1131,
	"./seat-icon.svg": 1132,
	"./seat-icons/3-wheelChair.png": 1133,
	"./seat-icons/block_seat_new.png": 1134,
	"./seat-icons/broken-seat-1.svg": 1135,
	"./seat-icons/broken-seat-2.svg": 1136,
	"./select-food.png": 751,
	"./settings.svg": 1137,
	"./show-password.svg": 382,
	"./slider-triangle.svg": 741,
	"./snack.svg": 752,
	"./sort.svg": 1138,
	"./star-empty.svg": 1139,
	"./star-fill.svg": 1140,
	"./success-tick.svg": 1141,
	"./suitcase.svg": 1142,
	"./swap.svg": 1143,
	"./tick-green-item.svg": 753,
	"./tick-green.svg": 1144,
	"./ticket-icon.svg": 1145,
	"./trash.svg": 1146,
	"./unpaid-reservation.svg": 723,
	"./updown-white.svg": 1147,
	"./updown.svg": 1148,
	"./user-attribute.svg": 1149,
	"./user-attributes.svg": 1150,
	"./user-female.svg": 1151,
	"./user-male-white.svg": 1152,
	"./user-male.svg": 1153,
	"./user-profile.svg": 1154,
	"./userProfile.png": 1155,
	"./veg-food-mark-white.png": 1156,
	"./veg-foog-mark-trans.png": 1157,
	"./view.png": 1158,
	"./view.svg": 1159
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 981;


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons ^\.\/.*$
// module id = 981
// module chunks = 38